export const DEBUG = true

export const BASE_PROXY_URL = DEBUG ? "https://chatwooot-bots.loca.lt" : "https://chatwoot-proxy.neurobotnik.ru"
